// External article / video for each item. Leave "" when none exists:
// the card then renders without a link or arrow.
export const mediaLinks = {
  "top-10-agritech-visionaries-driving-innovation-and-growth": "",
  "neville-patel-ceo-of-qualitas-global-on-ai-business-and-tough-leadership-calls":
    "https://www.techdogs.com/inspire/discover-dialogues/ai-business-leadership-neville-patel-discover-dialogues-podcast",
  "day-in-the-life-with-neville-patel": "",
  "the-most-influential-entrepreneur-shaping-the-future-of-machine-learning-and-ai-2025": "",
  "top-10-most-influential-business-leaders-to-watch-in-2024": "",
  "most-promising-ai-companies-shaping-our-future": "",
  "top-10-data-annotation-and-labeling-service-providers-in-india": "",
  "the-best-data-collection-licensing-service-provider-2024":
    "https://theenterpriseworld.com/qualitas-global-revolutionizing-industries/",
  "qualitas-global-ai-a-businesses-with-the-magic-of-artificial-intelligence": "",
  "top-visionary-ceos-in-2024":
    "https://timesofindia.indiatimes.com/business/india-business/top-visionary-ceos-in-2024/articleshow/107318151.cms",
  "interview-in-silicon-india":
    "https://enterprise-services.siliconindia.com/ranking/data-image-annotation-companies-2021-rid-1139.html",
  "most-valuable-ceos":
    "https://issuu.com/fanzineindia/docs/25_most_valueble_ceo_s_in_india___20_most_innovati",
  "interview-in-parsiana":
    "https://nevillepatel.in/wp-content/uploads/2023/03/Neville-Patel-Business-March-7-2023.pdf",
  "the-enterprise-world":
    "https://theenterpriseworld.com/qualitas-global-services-neville-patel/",
  "ensuring-world-class-services-in-data-annotation-mobile-games-qa":
    "https://businessconnectindia.in/qualitas-global-data-annotation/",
  "qualitas-global-a-premium-data-annotation-services-company": "",
};

// `image` is the file name (without extension) in src/assets/media/, e.g. "1" -> 1.webp
const items = [
  {
    id: 3495,
    slug: "top-10-agritech-visionaries-driving-innovation-and-growth",
    title: "Top 10 AgriTech Visionaries Driving Innovation and Growth",
    source: "",
    image: "1",
    imageAlt: "Top 10 AgriTech Visionaries Driving Innovation and Growth",
  },
  {
    id: 3130,
    slug: "neville-patel-ceo-of-qualitas-global-on-ai-business-and-tough-leadership-calls",
    title: "Neville Patel, CEO of Qualitas Global, On AI, Business, And Tough Leadership Calls",
    source: "",
    image: "2",
    imageAlt: "Neville Patel, CEO of Qualitas Global, On AI, Business, And Tough Leadership Calls",
  },
  {
    id: 3126,
    slug: "day-in-the-life-with-neville-patel",
    title: "Day In The Life with Neville Patel",
    source: "",
    image: "3",
    imageAlt: "Day In The Life with Neville Patel",
  },
  {
    id: 2683,
    slug: "the-most-influential-entrepreneur-shaping-the-future-of-machine-learning-and-ai-2025",
    title: "The Most Influential Entrepreneur Shaping the Future of Machine Learning and AI - 2025",
    source: "",
    image: "4",
    imageAlt: "The Most Influential Entrepreneur Shaping the Future of Machine Learning and AI - 2025",
  },
  {
    id: 2675,
    slug: "top-10-most-influential-business-leaders-to-watch-in-2024",
    title: "Top 10 Most Influential Business Leaders to Watch in 2024",
    source: "",
    image: "5",
    imageAlt: "Top 10 Most Influential Business Leaders to Watch in 2024",
  },
  {
    id: 2653,
    slug: "most-promising-ai-companies-shaping-our-future",
    title: "Most promising AI companies shaping our future",
    source: "",
    image: "6",
    imageAlt: "Most promising AI companies shaping our future",
  },
  {
    id: 2648,
    slug: "top-10-data-annotation-and-labeling-service-providers-in-india",
    title: "Top 10 Data Annotation And Labeling Service Providers In India",
    source: "",
    image: "7",
    imageAlt: "Top 10 Data Annotation And Labeling Service Providers In India",
  },
  {
    id: 2607,
    slug: "the-best-data-collection-licensing-service-provider-2024",
    title: "The Best Data Collection & Licensing Service Provider- 2024",
    source: "The Enterprise World",
    image: "8",
    imageAlt: "The Best Data Collection & Licensing Service Provider- 2024",
  },
  {
    id: 2527,
    slug: "qualitas-global-ai-a-businesses-with-the-magic-of-artificial-intelligence",
    title: "Qualitas Global AI- A Transformative Force Empowering Businesses with the Magic of Artificial Intelligence",
    source: "",
    image: "9",
    imageAlt: "Qualitas Global AI- A Transformative Force Empowering Businesses with the Magic of Artificial Intelligence",
  },
  {
    id: 2099,
    slug: "top-visionary-ceos-in-2024",
    title: "Neville Patel, featured as one of the Top 15 Visionary CEOs of 2024 by the Times of India",
    source: "Times of India",
    image: "10",
    imageAlt: "Neville Patel News",
  },
  {
    id: 1836,
    slug: "interview-in-silicon-india",
    title: "Qualitas Global, awarded the 10 Most Promising Data & Image Annotation Companies",
    source: "Silicon India",
    image: "11",
    imageAlt: "Qualitas Global, awarded the 10 Most Promising Data & Image Annotation Companies",
  },
  {
    id: 1831,
    slug: "most-valuable-ceos",
    title: "Most valuable CEO's",
    source: "Fanzine India",
    image: "12",
    imageAlt: "Most valuable CEO's",
  },
  {
    id: 1820,
    slug: "interview-in-parsiana",
    title: "Interview in Parsiana",
    source: "Parsiana",
    image: "13",
    imageAlt: "Interview in Parsiana",
  },
  {
    id: 100,
    slug: "the-enterprise-world",
    title: "The Enterprise World",
    source: "The Enterprise World",
    image: "14",
    imageAlt: "The Enterprise World",
  },
  {
    id: 1841,
    slug: "ensuring-world-class-services-in-data-annotation-mobile-games-qa",
    title: "Ensuring World Class Services In Data Annotation & Mobile Games QA",
    source: "Business Connect India",
    image: "15",
    imageAlt: "Ensuring World Class Services In Data Annotation & Mobile Games QA",
  },
  {
    id: 1828,
    slug: "qualitas-global-a-premium-data-annotation-services-company",
    title: "Qualitas Global: A Premium Data Annotation Services Company",
    source: "",
    image: "16",
    imageAlt: "Qualitas Global: A Premium Data Annotation Services Company",
  },
];

export const mediaPosts = items.map((item) => ({
  ...item,
  type: "media",
  url: mediaLinks[item.slug] || "",
  hasExternalLink: Boolean(mediaLinks[item.slug]),
}));
